import { goToLogin } from 'core/use-cases/goToLogin'

import { user } from 'legacy/utils/user'

export function expireSession() {
  if (!user.isLoggedIn()) return

  user.logout()
  goToLogin()
  window.location.reload()
}
